<template>
  <v-select
    :data-test-id="dataTestId"
    :label="label"
    v-model="valueInternal"
    :disabled="disabled"
    :items="availableItems"
    :rules="rules"
    item-text="name"
    item-value="value"
    :prepend-icon="prependIcon"
    :autocomplete="autocomplete"
    :clearable="clearable"
  >
    <template v-slot:item="data">
      {{ data.item.name }}
    </template>

    <template v-slot:selection="data">
      {{ data.item.name }}
    </template>
  </v-select>
</template>

<script>
export default {
  name: "YearSelect",
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
    },
    rules: {
      default: undefined
    },
    value: {
      required: false
    },
    prependIcon: {
      type: String,
    },
    autocomplete: {
      type: String,
    },
    dataTestId: {
      type: String,
      required: false
    },
  },
  data: function() {
    let years = []
    let currentYear = new Date().getFullYear()
    for (var i=currentYear-5; i>currentYear-110; i--) {
        years.push({name: i, value: i})
    }

    return {
      valueInternal: undefined,
      years: years
    };
  },
  computed: {
    availableItems: function () {
      return this.years
    }
  },
  watch: {
    value: function(val) {
      this.valueInternal = val
    },
    valueInternal: function(val) {
      this.$emit("input", val)
    }
  },
  mounted() {
    this.valueInternal = this.value
  },
  methods: {}
};
</script>